import parse from "html-react-parser"
import { withRouter, Link } from "react-router-dom"
import React, { useState } from "react"
import {
  Card,
  Button,
  CardBody,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import { getData } from "./data"
import { deletePromotion } from "store/Marketing/actions"
import { useSelector, useDispatch } from "react-redux"
import { imagePath } from "constants/constants"
import { hasPermission } from "helpers/helpers"

function Table(props) {
  const { data } = props
  const dispatch = useDispatch()

  const handleEdit = (row, e) => {
    e.preventDefault()
    props.history.push(`${window.location.pathname}/edit?id=${row.id}`)
  }
  const columns = [
    {
      dataField: "id",
      text: "Id",
      sort: true,
    },
    {
      dataField: "start_date",
      text: "Start Date",
      sort: true,
      formatter:(cell,row) => (
          <>{row.start_date.split("-").reverse().join("-")}</>
      ),
    },
    {
      dataField: "end_date",
      text: "End Date",
      sort: true,
      formatter:(cell,row) => (
          <>{row.end_date.split("-").reverse().join("-")}</>
      ),
    },
    {
      dataField: "end_date",
      text: "Banner",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <>
            <img
              src={`${imagePath("banners", row?.banner)}`}
              alt="product-img"
              title="product-img"
              className="avatar-md"
            />
          </>
        )
      },
    },
    {
      dataField: "promotion_type",
      text: "Promotion Type",
      sort: true,
    },
    // {
    //   dataField: "header",
    //   text: "Blurb Header",
    //   sort: true,
    // },
    // {
    //   dataField: "short_body",
    //   text: "Blurb Short body",
    //   sort: true,
    // },
    // {
    //   dataField: "description",
    //   text: "Description",
    //   sort: true,
    //   formatter: (cellContent, row) => {
    //     let desc = row["description"]
    //     return <>{parse(desc)}</>
    //   },
    // },
    {
      dataField: "status",
      text: "status",
      sort: true,
      formatter: (cellContent, row) => {
        let status = row.status == 1 ? "active" : "inactive"
        return <div className="text-body fw-bold">{status}</div>
      },
    },

    {
      dataField: "action",
      isDummyField: true,
      text: "Action",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <>
          <div className="d-flex gap-3">
            {hasPermission("update-marketing") && (
              <Link
                to="#"
                className="text-success"
                onClick={e => handleEdit(row, e)}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Edit
                </UncontrolledTooltip>
              </Link>
            )}

            {hasPermission("delete-marketing") && (
              <Link
                to="#"
                className="text-danger"
                onClick={e => {
                  dispatch(deletePromotion(row.id))
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Delete
                </UncontrolledTooltip>
              </Link>
            )}
          </div>
        </>
      ),
    },
  ]

  const defaultSorted = [
    {
      dataField: "orderId",
      order: "desc",
    },
  ]

  const { SearchBar } = Search
  //pagination customization

  const pageOptions = {
    sizePerPage: 10,
    totalSize: getData().length,
    custom: true,
  }

  const handleClick = () => {
    props.history.push("/crm/marketing/create")
  }
  return (
    <>
      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">{"Available Promotions"}</div>
          <PaginationProvider
            pagination={paginationFactory(pageOptions)}
            keyField="id"
            columns={columns}
            data={data}
          >
            {({ paginationProps, paginationTableProps }) => (
              <ToolkitProvider
                keyField="id"
                data={data}
                columns={columns}
                bootstrap4
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <Row className="mb-2">
                      <Col sm="4">
                        <div className="search-box me-2 mb-2 d-inline-block">
                          <div className="position-relative">
                            <SearchBar {...toolkitProps.searchProps} />
                            <i className="bx bx-search-alt search-icon" />
                          </div>
                        </div>
                      </Col>
                      <Col sm="8">
                        {hasPermission("create-marketing") && (
                          <div className="text-sm-end">
                            <Button
                              type="button"
                              color="success"
                              className="btn-rounded  mb-2 me-2"
                              onClick={handleClick}
                            >
                              <i className="mdi mdi-plus me-1" />
                              Create New Promotion
                            </Button>
                          </div>
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col xl="12">
                        <div className="table-responsive">
                          <BootstrapTable
                            keyField="id"
                            responsive
                            bordered={false}
                            striped={false}
                            defaultSorted={defaultSorted}
                            //   selectRow={selectRow}
                            classes={
                              "table align-middle table-nowrap table-check"
                            }
                            headerWrapperClasses={"table-light"}
                            {...toolkitProps.baseProps}
                            {...paginationTableProps}
                            rowClasses={"mytable-hover-row"}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="pagination pagination-rounded justify-content-end">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </React.Fragment>
                )}
              </ToolkitProvider>
            )}
          </PaginationProvider>
        </CardBody>
      </Card>
    </>
  )
}

export default withRouter(Table)
